import { Wrapper } from './nav.styles';

import RewardoLogo from '../../common/rewardo_logo';
import Menu from './menu';
import RegisterBanner from './register_banner';

export default function Nav() {
  return (
    <Wrapper>
      <RewardoLogo width={133} />
      <RegisterBanner />
      <Menu />
    </Wrapper>
  );
}
